export default __webpack_public_path__ + "static/media/money-back.2fb78f7f.jpg";